<template>
  <div class="salesmantuijianPage">
    <XR-head :titleText="pageTitle" :rightShow="false" ref="headObj"></XR-head>
      <mu-list>
        <mu-list-item class="proList" v-for="mItem in memberList" :key="mItem.minnerbm">
            <div class="mu-item-title">
                 <div class="list-content">
                     <img class="list-icon" :src="mItem.headPic" alt="">
                    <div class="dd1">
                       <p>{{mItem.userbm}}</p>
                       <p class="telephone">{{mItem.mobile}}</p>
                       <p class="number">{{mItem.reallyname}}</p>                     
                    </div>           
                    <div class="dd2">
                      <!-- <p class="type">{{mItem.tlayerName}}</p> -->
                      <p class="font-color">{{mItem.zcpvname}}</p>
                      <p class="date">{{mItem.shsjname}}</p>
                      
                    </div>
                </div>             
            </div>
        </mu-list-item>
    </mu-list>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data(){
    return {      
     searchInfo:{
       pageIndex:1,
       pageSize:1000,
       userbs: this.$route.query.userbs,
       startdate:'',
       enddate:'',
       tjbs:'1'
     },
     userbs:this.$route.query.userbs,
     memberList:[],
     pageTitle: this.$route.query.pageTitle
    }
  },
  mounted(){
    this.getMemberList()
  },
  methods:{    
    getMemberList(){      
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetTuijianRelationStream", this.searchInfo)
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.memberList = res.Data.List
          ths.$refs.XRPageTip.initTip()
          ths.$refs.XRtoast.hide();
        }else{
          ths.memberList = []
          ths.$refs.XRPageTip.ShowEmpty('暂无数据')
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    }    
  }
}
</script>


<style>
        body .salesmantuijianPage{
          background: #fff;
          bottom: unset;
        }
        .salesmantuijianPage .list-icon{
          width: 35px;
          height: 35px;
          border-radius: 50%;
          -o-object-fit: cover;
          object-fit: cover;
          float: left;
        }
        .salesmantuijianPage .dd1
        {
            float:left;
            width: 50%;
            padding-left: 5%;
            text-align:left;
        }
      .salesmantuijianPage .dd1,.salesmantuijianPage .dd2 {
        font-size: 12px;
        }
      .salesmantuijianPage .dd1 .number{
        color: #999;
        }
      .salesmantuijianPage .dd2 .date { font-size:12px;color:#999;}
      .salesmantuijianPage .dd2
        {
            float: right;;
            width:29%;
            text-align:center;
            padding-left:2%;
            font-size:12px;
        }
     .salesmantuijianPage .dd2 .type { font-size:14px;}
     .salesmantuijianPage .dd2 .telephone{
       font-size: 12px
     }
     .salesmantuijianPage .dd3{
        float:left;
        width:20%;
        text-align:center;
      }
      .salesmantuijianPage .mu-raised-button{
        min-width: 0px;
      }
      .salesmantuijianPage .proList{
          border-bottom: 1px solid #f5f5f5;
      }
      .salesmantuijianPage .proList:last-child{
          border:none;
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/mytuijianlist.vue